var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "share-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.25 10.125C12.3849 12.8273 6.75 20.1189 6.75 28.69C6.75 31.4053 7.31551 33.9921 8.3383 36.3452M33.75 10.125C41.6151 12.8273 47.25 20.1189 47.25 28.69C47.25 30.9906 46.8439 33.1992 46.0978 35.2517M37.125 45.7416C34.1465 47.4165 30.6884 48.375 27 48.375C23.3116 48.375 19.8535 47.4165 16.875 45.7416",
    stroke: "white",
    strokeWidth: 3.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.75 11.25C33.75 14.9779 30.728 18 27 18C23.272 18 20.25 14.9779 20.25 11.25C20.25 7.52209 23.272 4.5 27 4.5C30.728 4.5 33.75 7.52209 33.75 11.25Z",
    stroke: "white",
    strokeWidth: 3.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.25 49.5C14.9779 49.5 18 46.4779 18 42.75C18 39.0221 14.9779 36 11.25 36C7.52208 36 4.5 39.0221 4.5 42.75C4.5 46.4779 7.52208 49.5 11.25 49.5Z",
    stroke: "white",
    strokeWidth: 3.375
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M42.75 49.5C46.4779 49.5 49.5 46.4779 49.5 42.75C49.5 39.0221 46.4779 36 42.75 36C39.0221 36 36 39.0221 36 42.75C36 46.4779 39.0221 49.5 42.75 49.5Z",
    stroke: "white",
    strokeWidth: 3.375
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.9d7f8b52719f36c7c2086a5ad49b9fe7.svg";
export { ForwardRef as ReactComponent };